import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import SensorDataDaily from './sensor-data-daily';
import SensorDataDailyDetail from './sensor-data-daily-detail';
import SensorDataDailyUpdate from './sensor-data-daily-update';
import SensorDataDailyDeleteDialog from './sensor-data-daily-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={SensorDataDailyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={SensorDataDailyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={SensorDataDailyDetail} />
      <ErrorBoundaryRoute path={match.url} component={SensorDataDaily} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={SensorDataDailyDeleteDialog} />
  </>
);

export default Routes;
